import { useRef } from "react";

import { ButtonPrimitive } from "@/components/elements/Button";
import { Input } from "@/components/primitives/input";
import { SearchIcon, XIcon } from "lucide-react";

export function SearchFilter(props: {
  searchTerm: string;
  onChange: (term: string) => void;
  placeholder?: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div className="relative flex w-full max-w-sm items-center">
      <Input
        ref={inputRef}
        placeholder={props.placeholder ?? "Filter..."}
        value={props.searchTerm}
        onChange={(e) => props.onChange(e.target.value)}
        size="md"
        className="h-8 w-full pl-10 text-sm"
        autoFocus
      />
      <div className="absolute top-0 left-0 flex h-full items-center px-2">
        <SearchIcon className="size-4 text-gray-400 dark:text-gray-400" />
      </div>
      {props.searchTerm.trim().length > 0 && (
        <div className="absolute top-0 right-0 z-10 flex h-full items-center px-2">
          <ButtonPrimitive
            className="opacity-50 hover:opacity-100"
            onClick={() => {
              props.onChange("");
              inputRef.current?.focus();
            }}
          >
            <XIcon className="size-5" />
          </ButtonPrimitive>
        </div>
      )}
    </div>
  );
}
